export default __webpack_public_path__ + "static/SuperRare-718ce75723c4d845a64497a20134a62a.png";